import axios from 'axios';

const ADMIN_URL = process.env.REACT_APP_API_URL + 'admin/';

const axiosConfig = {
  withCredentials: true
};

const getAccountPlan = (accountId) => {
  return axios.get(`${ADMIN_URL}account-plan/${accountId}`, axiosConfig);
};

const updateSpecs = (accountId, specs) => {
  return axios.put(`${ADMIN_URL}account-plan/${accountId}/specs`, { specs }, axiosConfig);
};

const getFeatures = () => {
  return axios.get(`${ADMIN_URL}plans/features`, axiosConfig);
};

// Re-reads the account's platform subscription from Stripe and applies its status.
const syncStripe = (accountId) => {
  return axios.post(`${ADMIN_URL}account-plan/${accountId}/sync-stripe`, {}, axiosConfig);
};

const AccountPlanService = {
  getAccountPlan,
  updateSpecs,
  getFeatures,
  syncStripe
};

export default AccountPlanService;
